const PadPresenceTesting = () => import('../views/PadPresenceTesting.vue')

export const padPresenceTestingRoutes = [
	{
		path: '/pad-presence-testing',
		name: 'padPresenceTesting',
		component: PadPresenceTesting,
	},
]
